module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/core-js/modules/_fails.js
// module id = 215
// module chunks = 16